import { isNil } from "lodash-es";
import IVendorModel from "../models/IVendorModel";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IOnGetVendorsDTO from "../models/DTO/IOnGetVendorsDTO";
import IGetVendorsQuery from "../models/DTO/IGetVendorsQuery";

const getLocalVendorData = (): Promise<IVendorModel> => {
    return new Promise((resolve, reject) => {
        try {
            const vendor = localStorage.getItem("vendor");

            if (isNil(vendor)) {
                reject(new Error("Error finding vendor in local storage."));
            } else {
                const parsedVendor = JSON.parse(vendor) as IVendorModel;

                resolve(parsedVendor);
            }
        } catch (err) {
            reject(err);
        }
    });
};

const getLocalVendorDataFn = (): IVendorModel => {
    const vendor = localStorage.getItem("vendor");

    if (isNil(vendor)) {
        console.log("No vendor found in local storage, returning empty vendor model.");
        return {} as IVendorModel;
    } else {
        const parsedVendor = JSON.parse(vendor) as IVendorModel;
        return parsedVendor;
    }
};

const saveVendorData = (data: any) => {
    data.dataAge = Date.now();

    const vendorData = JSON.stringify(data);

    localStorage.setItem("vendor", vendorData);
};

const clearVendorData = () => {
    return new Promise((resolve, reject) => {
        try {
            localStorage.removeItem("vendor");

            resolve(true);
        } catch (err) {
            reject(err);
        }
    });
};

const getVendors = async (query: IGetVendorsQuery, userModel: IUserUI, supplierModel: ISupplierModel): Promise<IOnGetVendorsDTO> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.VendorGetVendors,
        query,
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, { method: "GET", headers });

    if (!response.ok) {
        throw new Error(`Failed to fetch vendors: ${response.statusText}`);
    }

    return (await response.json()) as IOnGetVendorsDTO;
};

const VendorService = {
    clearVendorData,
    getLocalVendorData,
    getLocalVendorDataFn,
    getVendors,
    saveVendorData,
};

export default VendorService;
